module.exports = __webpack_public_path__ + "static/bathroom2-55299aa60fb4b526a8a7a9df07a0d6f0.jpg";